var incmodalopen 	= 0;
var incmodal2open 	= 0;
var incr_user_guid	= getCookie('incr_user_guid');

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function deleteCookie(cname) {
	setCookie(cname,'',-100)
}
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
   	return v.toString(16);
  });
}
function initSessionGUID() {
  	var incr_user_ref	= '';
	if (incr_user_guid == '') {
		incr_user_guid = generateGuid();
		incr_user_ref = document.referrer;
    }
    var d = new Date();
    d.setTime(d.getTime() + 1800000);
    var expires = "expires="+ d.toUTCString();
    document.cookie = 'incr_user_guid' + "=" + incr_user_guid + ";" + expires + ";path=/";
  	$.getScript('//embed.incredibleinventions.com/embed/guid/?incr_user_guid=' + incr_user_guid + '&incr_user_page=' + encodeURI(window.location) + '&incr_user_ref=' + encodeURI(incr_user_ref), function(data, textStatus, jqxhr) {});  
}
function getDayName(dateStr) {
    var date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'long' });        
}
function getQueryStringParameter(x) {
  x = x.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + x + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
function smoothScrollTo(x) {
	$('html, body').animate({scrollTop:$('#' + x).offset().top}, 'slow');
}
function smoothScrollTop() {
  $('html, body').animate({scrollTop:0}, 'slow'); 	 
}

function smoothScrollToClass(x) {
	$('html, body').animate({scrollTop:$('.' + x).offset().top}, 'slow');
}
function loadIncModal(x,allowclose,ignoreifopen) {
	incmodalopen = 1;
	if (allowclose == 1) {$('.incmodal-close').show();} else {$('.incmodal-close').hide();}
  
  	if ((x.substring(0, 7) == 'http://') || (x.substring(0, 8) == 'https://') || (x.substring(0, 2) == '//') || (x.substring(0, 1) == '/')) {
		$('#incmodal-inner').html('<div style=\"width:60px;margin:auto;display:block;\"><div class=\"load-block_1 load_block\"></div><div class=\"load-block_2 load_block\"></div><div class=\"load-block_3 load_block\"></div></div><div class=\"clear\"></div>').load(x, function() {$(this).fadeIn();});
    } else {
		$('#incmodal-inner').html('<div class=\"sliminner\">' + x + '</div>');
    }
  	$('#container-incmodal').fadeIn(); 
}
function closeIncModal() {
  	incmodalopen = 0;
	$('#container-incmodal').fadeOut();
}
function reviewQorder(qorderguid) {
	$('#container-qorder').html('<div style=\"width:60px;margin:auto;display:block;\"><div class=\"load-block_1 load_block\"></div><div class=\"load-block_2 load_block\"></div><div class=\"load-block_3 load_block\"></div></div><div class=\"clear\"></div>').load('https://embed.incredibleinventions.com/embed/order/review.asp?qorderguid=' + qorderguid, function() {}); 
}
function loadIncModal2(x,allowclose,ignoreifopen) {
	incmodal2open = 1;
	if (allowclose == 1) {$('.incmodal2-close').show();} else {$('.incmodal2-close').hide();}
  
  	if ((x.substring(0, 7) == 'http://') || (x.substring(0, 8) == 'https://') || (x.substring(0, 2) == '//') || (x.substring(0, 1) == '/')) {
		$('#incmodal2-inner').html('<div style=\"width:60px;margin:auto;display:block;\"><div class=\"load-block_1 load_block\"></div><div class=\"load-block_2 load_block\"></div><div class=\"load-block_3 load_block\"></div></div><div class=\"clear\"></div>').load(x, function() {$(this).fadeIn();});
    } else {
		$('#incmodal2-inner').html('<div class=\"sliminner\">' + x + '</div>');
    }
  	$('#container-incmodal2').fadeIn(); 
}
function closeIncModal2() {
  	incmodal2open = 0;
	$('#container-incmodal2').fadeOut();
}
function help_ShowOpenTicket() {
	$('.row-openticket').addClass('hidden');
	$('.row-openticket').removeClass('althidden');
	$('.row-openticket').slideDown();
}
function help_ShowNewTicketForm() {
  $('.row-openticket').hide();
  $('.section-helptopics').slideUp();
  $('.section-ticketform').addClass('hidden');
  $('.section-ticketform').removeClass('althidden');
  $('.section-ticketform').slideDown();
}
function popupCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

	var left = ((screen.width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((screen.height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}

$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};